import actions from './actions';

const initState = {
  loading: false,
  pricingPlans: [],
  pricingPlan: {}
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case actions.START_FETCH_PRICINGPLANS:
      return { ...state, loading: true };
    case actions.END_FETCH_PRICINGPLANS:
      return { ...state, loading: false };
    case actions.START_DELETING_PRICINGPLANS:
      return { ...state, loading: true };
    case actions.END_DELETING_PRICINGPLANS:
      return { ...state, loading: false };
    case actions.START_ADD_PRICINGPLAN:
      return { ...state, loading: true };
    case actions.END_ADD_PRICINGPLAN:
      return { ...state, loading: false };
    case actions.START_FETCH_PRICINGPLAN:
      return { ...state, loading: true };
    case actions.END_FETCH_PRICINGPLAN:
      return { ...state, loading: false };
    case actions.START_UPDATE_PRICINGPLAN:
      return { ...state, loading: true };
    case actions.END_UPDATE_PRICINGPLAN:
      return { ...state, loading: false };
    case actions.SET_PRICINGPLANS:
      return { ...state, pricingPlans: action.value };
    case actions.SET_PRICINGPLAN:
      return { ...state, pricingPlan: action.value };
    default:
      return state;
  }
};

export default reducer;
